; (function ($, window, document, undefined) {
    'use strict';
    // nom de librairie à modifier
    Foundation.libs.product = {
        name: 'product',

        version: '1.0.0',

        settings: {
            callback: function () { }
        },
        module360: {},
        sliderImagesElm: {},
        sliderImages: {},
        sliderNavigationElm: {},
        sliderNavigation: {},
        sliderImagesZoomElm: {},
        sliderImagesZoomnavigationElm: {},
        sliderImagesZoom: {},
        sliderImagesZoomnavigation: {},
        sliderOtherProducts: {},
        sliderImagesOpt: {
            loop: true,
            nav: true,
            items: 1,
            lazyLoad: true,
            dots: true,
            touchDrag: false,
            stagePadding: 0,
            //navContainer: '#navigationMobile',
            dotsContainer: '#wrapper-dots',
            navText: ['<img src="/images/fiche_produit/v2/fleche-gauche.svg" width="40" height="100" class="show-for-small-only" alt="Flèche gauche" />', '<img src="/images/fiche_produit/v2/fleche-droite.svg" width="40" height="100" class="show-for-small-only" alt="Flèche droite" />']
        },
        sliderNavigationOpt: {
            loop: true,
            nav: true,
            items: 5,
            lazyLoad: true,
            dots: false,
            stagePadding: 0,
            navText: ['<img src="/images/fiche_produit/v2/fleche-gauche.svg" width="40" height="100" class="show-for-small-only" alt="Flèche gauche" />', '<img src="/images/fiche_produit/v2/fleche-droite.svg" width="40" height="100" class="show-for-small-only" alt="Flèche droite" />']
        },
        sliderImagesZoomOpt: {
            loop: true,
            nav: false,
            navText: ['', ''],
            items: 1,
            lazyLoad: true,
            dots: false,
            stagePadding: 0
        },
        sliderImagesZoomNavigationOpt: {
            loop: true,
            nav: true,
            navText: ['<img src="/images/fiche_produit/v2/fleche-gauche.svg" width="40" height="100" alt="Flèche gauche" />', '<img src="/images/fiche_produit/v2/fleche-droite.svg" width="40" height="100" alt="Flèche droite" />'],
            items: 3,
            lazyLoad: true,
            dots: false,
            stagePadding: 0,
            responsive: {
                0: {
                    items: 3
                },
                641: {
                    items: 4,
                    nav: true
                }
            }
        },

        productReveal: {},
        //interval: {},
        init: function (scope, method, options) {
            // initialisation à conserver
            Foundation.inherit(this, '');
            var self = this;

            // votre code ici
            /* // exemple
            if (self.S("#" + this.settings.id).length === 0)
                self.S("#main-content", this.scope).append("<span id='" + this.settings.id + "'></span>");
            */
            //this.interval;
            this.productReveal;
            this.sliderImagesElm = $("#owl-product-slider");
            this.sliderNavigationElm = $("#owl-navigation-slider");
            this.sliderOtherProducts = $("#slider-related-products, #slider-complementary-products, #slider-musthave-products, #slider-lastvisited-products");

            $(".o-products .owl-carousel").each(function (index, item) {
                var responsive = {
                    600: {
                        items: 2,
                        loop: true,
                        mouseDrag: ($(item).find('.item').length > 2),
                        touchDrag: ($(item).find('.item').length > 2),
                        margin: 10,
                        stagePadding: 40,
                        dots: false,
                        nav: false,
                        rewind: true,
                    },
                    1020: {
                        items: 2,
                        loop: true,
                        mouseDrag: ($(item).find('.item').length > 3),
                        touchDrag: ($(item).find('.item').length > 3),
                        dots: false,
                        nav: false,
                        rewind: true,
                    },
                    1200: {
                        items: 4,
                        loop: true,
                        mouseDrag: ($(item).find('.item').length > 4),
                        touchDrag: ($(item).find('.item').length > 4),
                        stagePadding: 0,
                        margin: 10,
                        rewind: true,
                    }
                };

                $(item).owlCarousel({
                    items: 1,
                    stagePadding: 30,
                    loop: true,
                    margin: 10,
                    nav: true,
                    navText: ['4', '5'],
                    dots: true,
                    mouseDrag: true,
                    touchDrag: true,
                    responsive: responsive,
                    rewind: true
                });

            });
            // à conserver
            this.bindings(method, options);
            var imagesProduct = document.querySelectorAll(".m-productZoom")
            for (var i = 0; i < imagesProduct.length; i++) {
                var imageProductZoom = new ZoomProduct(imagesProduct[i], { maxScale: 1.6 });
            }
        },
        initFormulaire: function () {
            try {
                $("#crosssell-add, .option").msDropdown({ roundedBorder: false });
                $(".duos, .parure").msDropdown({ roundedBorder: false, rowHeight: 40 });
                //$(".crosssell-quantity").msDropdown({ mainCSS: 'dd2' });
            } catch (e) {
                alert(e.message);
            }

        },
        initSliderImages: function () {
            var _this = this;
            var dateStart = null;
            //alert('init : ' + this.sliderImagesElm);
            this.sliderImages = this.sliderImagesElm.owlCarousel(this.sliderImagesOpt);
            this.sliderNavigation = this.sliderNavigationElm.owlCarousel(this.sliderNavigationOpt);

            this.sliderImages.on('changed.owl.carousel', function (e) {
                var current = e.item.index;
                _this.sliderImages.attr("data-active-slide", current);
                var $elem = $(e.target).find(".owl-item").eq(current).find(".item");
                if ($elem.attr("id") === "module-360") {
                    _this.module360.init();
                } else {
                    if (_this.module360.isActive) {
                        _this.module360.destroy();
                    }
                }
            });

            this.sliderNavigation.on('changed.owl.carousel', function (e) {
                var current = e.item.index;
                //var src = $(e.target).find(".owl-item").eq(current).find("img").attr('src');
                //console.log('Image current is ' + src);

                $(".card").removeClass('card-selected');
                // $(e.target).find('[data-id-view=' + e.item.index + ']').addClass('card-selected');

                $(e.target).find(".owl-item").eq(current).find(".card").addClass('card-selected');
            });
            this.sliderImages.find(".owl-stage").bind("touchstart", function (event) {
                //event.preventDefault;
                dateStart = new Date();
            });
            this.sliderImages.find(".owl-stage").bind("touchend", function () {
                var dateEnd = new Date();
                if (dateEnd - dateStart < 150) {
                    $(document).foundation('product', 'initCarouselZoom', $(this).parents(".owl-carousel").attr('data-active-slide'));
                }

            });
        },
        initModule360: function () {

            this.module360 = new Module360("#module-360");
        },
        initSliderOtherProducts: function () {

            // On n'affiche pas la nav si moins d'éléments à afficher que nécessaire
            this.sliderOtherProducts.on('initialized.owl.carousel resized.owl.carousel', function (e) {
                $(e.target).toggleClass('hide-nav', e.item.count <= e.page.size);
            });

            this.sliderOtherProducts.each(function (index, item) {
                if (item.classList.contains("owl-carousel")) {
                    $(item).owlCarousel({
                        loop: true,
                        nav: true,
                        items: 3,
                        lazyLoad: true,
                        dots: false,
                        stagePadding: 0,
                        navText: ['', ''],
                        responsive: {
                            0: {
                                items: 2,
                                loop: true,
                                mouseDrag: ($(item).find('.item').length > 2),
                                touchDrag: ($(item).find('.item').length > 2),
                                nav: ($(item).find('.item').length > 2),
                            },
                            641: {
                                items: 2,
                                loop: true,
                                mouseDrag: ($(item).find('.item').length > 2),
                                nav: ($(item).find('.item').length > 2),
                                touchDrag: ($(item).find('.item').length > 2),
                            },
                            961: {
                                items: 3,
                                loop: true,
                                mouseDrag: ($(item).find('.item').length > 3),
                                touchDrag: ($(item).find('.item').length > 3),
                                nav: ($(item).find('.item').length > 3),
                            }
                        }
                    });
                } else {
                    const images = item.querySelectorAll("img.owl-lazy");
                    images.forEach(image => {
                        const src = image.getAttribute('data-src');
                        if (src) {
                            image.src = src;
                        }
                    })
                }
            });
            Foundation.libs.common.initTrackMerch();
        },
        initCacListeners: function () {
            $(this.scope).one('submit', '#clickncollect-jewellery-form', function cacVariantFormCheck(e) {
                e.preventDefault();
                if ($("#TypeVariante").length && !$("#ProductVariant").val()) {
                    switch ($("#TypeVariante").val()) {
                        case 'L':
                            $('#erreur-globale .error-text').html("Choisissez l'initiale de votre bijou.");
                            $('#erreur-globale').foundation('reveal', 'open');
                            $(this).one('submit', cacVariantFormCheck);
                            break;
                        case 'C':
                            $('#erreur-globale .error-text').html("Choisissez la couleur de votre bijou.");
                            $('#erreur-globale').foundation('reveal', 'open');
                            $(this).one('submit', cacVariantFormCheck);
                            break;
                        case '':
                            $(this).submit();
                            break;
                        default:
                            $('#erreur-globale .error-text').html("Choisissez la taille de votre bijou.");
                            $('#erreur-globale').foundation('reveal', 'open');
                            $(this).one('submit', cacVariantFormCheck);
                            break;
                    }
                }
                else {
                    $(this).submit();
                }
            });
        },
        initAccordeonDescription: function () {
            if ($(window).width() < 640) {
                let dropdowns = $('.panel-dropdown');
                if (dropdowns.length > 0) {
                    dropdowns.each((index, dropdown) => {
                        $(dropdown).slideUp();
                    })
                }
            }
        },
        events: function () {
            var self = this;
            var S = this.S;
            //////////////////////////////////////////////////////////////
            //                          ETAPE1                          //
            //////////////////////////////////////////////////////////////
            $(this.scope)
                .ready(function (event) {
                    //tres important pour eviter le cache pour les requetes JSON
                    $.ajaxSetup({ cache: false });
                    if ($("#module-360")) {
                        $(document).foundation('product', 'initModule360');
                    }
                    $(document).foundation('product', 'initFormulaire');
                    $(document).foundation('product', 'initSliderImages');
                    $(document).foundation('product', 'initSliderOtherProducts');
                    $(document).foundation('product', 'initCacListeners');
                    $(document).foundation('product', 'initAccordeonDescription');

                    var $erreur = $('#displayerreur');
                    if ($erreur.length) {
                        $('#erreur-globale .error-text').html($erreur.val());
                        $('#erreur-globale').foundation('reveal', 'open');
                    }
                    var $message = $('#displaymessage');
                    if ($message.length) {
                        $('#popin_infos #content-text').html($message.val());
                        $('#popin_infos').foundation('reveal', 'open');
                    }

                    // Affichage de la modal ClicknCollect ajout au panier si redirection depuis la page de choix de bijouterie.
                    if ($("#cacRedirect").length) {
                        if ($("#cacRedirect").val() == "1") {
                            $("#cacRedirect").val("0");
                            $('#popin_infos #content-text > p').html("Votre produit a bien été ajouté à votre panier");
                            $('#popin_infos').foundation('reveal', 'open');
                        }
                    }
                })
                // AJOUT AU PANIER
                .on('submit', '#add-product-to-cart-form', function (e) {
                    var self = this;
                    e.preventDefault();
                    $('#add-to-cart-button').attr('disabled', 'disabled');

                    $.ajax(
                        {
                            cache: false,
                            async: true,
                            type: "POST",
                            url: $(this).attr('action'),
                            data: $(this).serialize(),
                            success: function (data) {
                                if (data.Success) {
                                    $('#add-to-cart-button').removeAttr('disabled');

                                    var opt = {};
                                    if (!data.HasEngraving) {
                                        opt = {
                                            product_size: data.ProductSize,
                                        }
                                    }
                                    else {
                                        opt = {
                                            product_size: data.ProductSize,
                                        }
                                    }

                                    if (typeof data.UrlToRedirect !== "undefined") {
                                        window.location = data.UrlToRedirect;
                                    }
                                    else {
                                        $('#product-informations').html(data._ProductInformations);

                                        // Feedback en affichant le survol du panier si on n'est pas sur mobile
                                        Foundation.libs.common.clearLightCart();

                                        // MAJ du datalayer
                                        $(document).foundation('common', 'refreshMasterTagData', data._MasterTagJson);
                                        $(document).foundation('common', 'refreshMasterTag');

                                        // Affichage de la modale d'ajout au panier
                                        var ref = $('#ReferenceProduit').attr('value');

                                        $.ajax({
                                            url: '/Product/AddToCartModal',
                                            data: { reference: ref },
                                            success: function (result) {
                                                if (result.IsValid) {
                                                    $('#ajout-produit-panier').html(result._AddProductModal)
                                                    $('#addProductReveal').foundation('reveal', 'open')
                                                    this.productReveal = new ProductReveal();
                                                }
                                                Foundation.libs.common.hidePreloader();
                                            },
                                            beforeSend: function () {
                                                Foundation.libs.common.showPreloader();
                                            }
                                        }).fail(function (e) {
                                            Foundation.libs.common.hidePreloader();
                                        });
                                    }
                                }
                                else {
                                    $('#erreur-globale .error-text').html(data.Message);
                                    $('#erreur-globale').foundation('reveal', 'open');
                                    $('#add-to-cart-button').removeAttr('disabled');
                                    Foundation.libs.common.hidePreloader();
                                }

                                $('#add-to-cart-button').removeAttr('disabled');

                            },
                            beforeSend: function () {
                                $('#preloader').show()
                                Foundation.libs.common.showPreloader();
                            },
                            complete: function () {
                                $('#add-to-cart-button').removeAttr('disabled');
                                //$('#preloader').hide();
                            }
                        }).fail(function (e) {
                            Foundation.libs.common.hidePreloader();
                        });

                    return false;
                })
                //CLOSING MODAL FOR BUTTON
                .on('click', '.close-reveal-modal-product-reveal', function (event) {
                    $('#addProductReveal').foundation('reveal', 'close')
                })
                // CARROUSEL VUES PRODUIT
                // -- CLIC VIGNETTES
                .on('click', '#navigation .card', function (event) {
                    event.preventDefault();
                    $(document).foundation('product', 'carouselViewsTo', $(this).attr('data-id-view'));
                })

                .on('click', '#owl-product-slider-zoom-navigation .card', function (event) {
                    event.preventDefault();
                    $(document).foundation('product', 'carouselZoomViewsTo', $(this).attr('data-id-view'));
                })

                // -- CLIC NAVITAGION NEXT
                .on('click', '#navigation .next', function (event) {
                    event.preventDefault();
                    $(document).foundation('product', 'carouselViewsNext', $(this).attr('data-id-view'));
                })
                // -- CLIC NAVITAGION PREV
                .on('click', '#navigation .prev', function (event) {
                    event.preventDefault();
                    $(document).foundation('product', 'carouselViewsPrev', $(this).attr('data-id-view'));
                })
                // ZOOM VUES PRODUIT
                // -- CLIC IMAGES
                .on('click', '.full-screen-zoom', function (event) {
                    event.preventDefault();
                    $(document).foundation('product', 'initCarouselZoom', $(this).attr('data-active-slide'));
                })
                // CHOIX VARIANTE - DESKTOP
                .on("click", ".bt-variant-choice", function (e) {
                    var product = $(this).attr('data-product-reference');
                    var variant = $(this).attr('data-variant');
                    var tooltip = $("#" + $(this).attr('data-selector'));
                    $.ajax({
                        url: '/ProductAction/SetVariante',
                        data: {
                            reference: product,
                            variante: variant
                        },
                        success: function (result) {
                            if (result.IsValid) {
                                $("#product-informations").html(result._Informations);

                                if (result._Details != null && result._Details.length > 0) {
                                    $("#product-details").html(result._Details);

                                    $(document).foundation('tab', 'reflow');
                                }

                                if (result.IsReloadImages) {
                                    $("#product-images-wrapper").html(result._Images);
                                }
                            }
                            $(document).foundation('accordion', 'reflow');
                        },
                        beforeSend: function () {
                            $(document).foundation('common', 'showPreloader');
                            tooltip.remove();
                        },
                        complete: function () {
                            $(document).foundation('common', 'hidePreloader');
                            $(".tooltip").remove();
                            $(document).foundation('tooltip', 'reflow');

                            // Récréation de la liste avec les options, affiner si une liste qui n'a rien a voir est affecté par cette ligne de code
                            msBeautify.create('select');

                            // Mise à jour de la référence pour ajout à la wishlist (cas des fusions de variantes sur une même fiche produit)
                            $("#button-add-to-wishlist-2").attr('data-reference', product);
                        },
                        cache: false
                    });
                })
                // CHOIX VARIANTE - MOBILE
                .on('change', ".dd-variante-dropdown", function (e) {
                    var product = $(this).find(':selected').data('reference')
                    var variant = $(this).val();
                    $.ajax({
                        url: '/ProductAction/SetVariante',
                        data: {
                            reference: product,
                            variante: variant
                        },
                        success: function (result) {
                            if (result.IsValid) {
                                $("#product-informations").html(result._Informations);

                                if (result._Details != null && result._Details.length > 0) {
                                    $("#product-details").html(result._Details);
                                }

                                if (result.IsReloadImages) {
                                    $("#product-images-wrapper").html(result._Images);
                                }
                            }
                            $(document).foundation('accordion', 'reflow');
                        },
                        beforeSend: function () {
                            $(document).foundation('common', 'showPreloader');
                        },
                        complete: function () {
                            // Mise à jour de la référence pour ajout à la wishlist (cas des fusions de variantes sur une même fiche produit)
                            $("#button-add-to-wishlist-2").attr('data-reference', product);

                            $(document).foundation('common', 'hidePreloader');
                        },
                        cache: false
                    });
                })
                // E RESERVATION - CLIC BOUTON
                .on('click', '#show-clickandcollect', function (e) {
                    var popinClickAndCollect = $("#retrait-bijouterie-wrapper");
                    var gravuresCheck = $(".checkbox-gravure-inline:checked");

                    if (gravuresCheck !== undefined && gravuresCheck.length > 0) {
                        // Si au moins une gravure de prédéfinie, on affiche un message d'avertissement
                        popinClickAndCollect = $("#ajax-modal-medium");
                    }

                    var reference = $(this).attr('data-product-reference');

                    // Ouverture Popin
                    $.ajax(
                        {
                            cache: false,
                            async: true,
                            type: "GET",
                            url: '/Product/ShowEreservationModal/',
                            data: { reference: reference },
                            success: function (data) {
                                popinClickAndCollect.html(data).foundation('reveal', 'open');
                            },
                            beforeSend: function () {
                                $('#preloader').show()
                            },
                            complete: function () {
                                $('#preloader').hide();
                            }
                        });

                    // Tracking
                    Foundation.libs.product.trackProduct("e_reservation", "e_reservation", "demande e-reservation");
                })
                // E-RESERVATION : CHOIX BIJOUTERIE
                .on("change", '#ereservation-jewelleries-list', function () {
                    $.ajax(
                        {
                            cache: false,
                            async: true,
                            type: "GET",
                            url: '/Product/EreservationCheckAvailability/',
                            data: {
                                jewelleryCode: $(this).val(),
                                reference: $('#Product_Reference').val()
                            },
                            success: function (data) {
                                $("#retrait-bijouterie-wrapper").html(data);

                                EnableButton();
                            },
                            beforeSend: function () {
                                $('#preloader').show()
                            },
                            complete: function () {
                                $('#preloader').hide();
                            }
                        });
                })
                // E-RESERVATION : CHOIX VARIANTE
                .on("change", '#ereservation-variants-list', function () {
                    $.ajax(
                        {
                            cache: false,
                            async: true,
                            type: "GET",
                            url: '/Product/EreservationCheckAvailability/',
                            data: {
                                jewelleryCode: $('#ereservation-jewelleries-list').val(),
                                reference: $('#Product_Reference').val(),
                                variant: $(this).val()
                            },
                            success: function (data) {
                                $("#retrait-bijouterie-wrapper").html(data);

                                EnableButton();
                            },
                            beforeSend: function () {
                                $('#preloader').show()
                            },
                            complete: function () {
                                $('#preloader').hide();
                            }
                        });
                })
                // E-RESERVATION : CLIC RESERVER CE PRODUIT
                .on('click', '#ereservation-booking', function (e) {
                    $.ajax(
                        {
                            cache: false,
                            async: true,
                            type: "GET",
                            url: '/Product/EreservationBooking/',
                            data: {
                                jewelleryCode: $('#ereservation-jewelleries-list').val(),
                                reference: $('#Product_Reference').val(),
                                variant: $('#ereservation-variants-list').val(),
                            },
                            success: function (data) {
                                $("#retrait-bijouterie-wrapper").html(data);

                                $(document).foundation('scroll', 'moveTo', $('.validation-retrait'));

                                EnableButton();
                            },
                            beforeSend: function () {
                                $('#preloader').show()
                            },
                            complete: function () {
                                $('#preloader').hide();
                            }
                        });
                })
                // Click and Collect V2 - CLIC BOUTON 
                .on('click', '.validation-clickandcollectV2', function (e) {
                    var popinClickAndCollect = $("#click-and-collectV2-validation-wrapper");

                    var reference = $(this).attr('data-product-reference');

                    popinClickAndCollect.foundation('reveal', 'open');
                })
                // PARTAGE PAR MAIL
                .on('click', 'a.social-share-email', function (e) {

                    var reference = $(this).attr('data-product-reference');
                    var popinWrapper = $('#ajax-modal-small');

                    // Ouverture Popin
                    $.ajax(
                        {
                            cache: false,
                            async: true,
                            type: "GET",
                            url: '/Product/ModalShareByEmail',
                            data: { reference: reference },
                            success: function (data) {
                                popinWrapper.html(data).foundation('reveal', 'open');
                            },
                            beforeSend: function () {
                                $('#preloader').show()
                            },
                            complete: function () {
                                $('#preloader').hide();
                            }
                        });
                })
                // TOOLTIP
                .on('click', '.more-content .more', function (e) {
                    e.preventDefault();

                    var $elem = $(e.currentTarget);
                    var $parentWrapper = $elem.next();
                    if ($elem.hasClass("-active")) {
                        $parentWrapper.hide();
                        $elem.removeClass("-active");
                    } else {
                        $elem.addClass("-active");
                        $parentWrapper.show();
                    }
                })
                .on('click', '.has-tooltip', function (e) {
                    e.preventDefault();
                    var $elem = $(e.currentTarget);

                    var $parentWrapper = $("#" + $elem.data('remote-id'));
                    $(".tooltip-term").hide();  // on ferme les autres tooltip
                    $parentWrapper.show();
                })
                .on('click', '.more-content .close', function (e) {
                    e.preventDefault();
                    var $elem = $(e.currentTarget).parent();
                    $elem.hide();

                })
                .on('click', '.tooltip-term .close-tooltip', function (e) {
                    e.preventDefault();
                    var $elem = $(e.currentTarget);
                    $elem.closest(".tooltip-term").hide();

                })
                // -- CLIC Ajout aux favoris > active le bouton
                .on('click', '.text-favoris', function (event) {
                    event.preventDefault();
                    $(event.currentTarget).siblings("button").trigger("click");
                })
                // CLICK VERS TABS
                // -- Avis clients
                .on('click', '.reviews-link', function (e) {
                    e.preventDefault();

                    if (this.hash.indexOf('small') == -1) { // Pour la version MEDIUM ou LARGE
                        $("#reviews-tab a").trigger("click");   // On ouvre l'onglet
                    }

                    $(document).foundation('scroll', 'moveTo', $(this.hash));
                })
                .on('click', '.characteristics-link', function (e) {
                    e.preventDefault();

                    //$("#characteristics-tab a").trigger("click");   // On ouvre l'onglet                
                    $("#informations-tab a").trigger("click");   // On ouvre l'onglet

                    $(document).foundation('scroll', 'moveTo', $(this.hash));
                })
                .on('click', '.product-back-button', function (e) {
                    e.preventDefault();
                    history.back()
                })
                // CLICK SUR ACCORDEON ACHAT - LOCATION
                .on('click', '#buy-link', function (e) {
                    e.preventDefault();

                    $(".rentingConditions").css('display', 'block');

                    $("#standard-price").show();
                    $("#renting-price").hide();

                    $("#product-warranty").show();
                    $("#included-service-renting").hide();
                    $("#included-service-selling").show();
                    $("#renting-steps").hide();
                })
                // CLICK SUR ACCORDEON ACHAT - LOCATION
                .on('click', '#rent-link', function (e) {
                    e.preventDefault();
                    $(".rentingConditions").css('display', 'none');

                    $("#renting-price").show();
                    $("#standard-price").hide();
                    $("#product-warranty").hide();

                    $("#included-service-renting").show();
                    $("#included-service-selling").hide();
                    $("#renting-steps").show();
                })
                // CLICK ACCORDEON DESCRIPTION MOBILE
                // Fix bug event double
                .off('click', '.panel-title')
                .on('click', '.panel-title', (e) => {
                    Foundation.libs.product.toggleDeployDescription(e);
                })
                // CLIC GUIDE DES TAILLES
                .on('click', '.baguier', function (e) {
                    $(document).foundation('mastertag', 'track_tc_event',
                    {
                        obj: "",
                        trigger: "guide_des_tailles",
                        options: {
                            id: "guide_des_tailles",
                            category: "guide des tailles",
                            action: tc_vars.product_name + "|" + tc_vars.product_id,
                            label: tc_vars.product_url,
                            value: tc_vars.product_unitprice_ati,
                            product_cat1: tc_vars.product_cat1,
                            product_cat2: tc_vars.product_cat2,
                            product_cat3: tc_vars.product_cat3,
                            product_category: tc_vars.product_category,
                            product_currency: tc_vars.product_currency,
                            product_discount_tf: tc_vars.product_discount_tf,
                            product_discount_ati: tc_vars.product_discount_ati,
                            product_gravable: tc_vars.product_gravable,
                            //product_engraved: tc_vars.product_engraved,
                            product_customizable: tc_vars.product_customizable,
                            product_id: tc_vars.product_id,
                            product_name: tc_vars.product_name,
                            product_promo: tc_vars.product_promo,
                            product_promo_label: tc_vars.product_promo_label,
                            product_quantity: tc_vars.product_quantity,
                            product_rating: tc_vars.product_rating,
                            product_size: tc_vars.product_size,
                            product_trademark: tc_vars.product_trademark,
                            product_unitprice_ati: tc_vars.product_unitprice_ati,
                            product_unitprice_tf: tc_vars.product_unitprice_tf
                        }
                    });
                })
        },
        reflow: function () { },
        // Modification bijouterie faite, on ajoute le produit sur la nouvelle bijouterie

        sucessChangeJewelleryCac: function (data) {
            $(document).foundation('common', 'showPreloader');
            $("#form-counter-add").submit();
        },
        //Vérifie si le changement de bijouterie à un impacte ou non
        successAddProductCac: function (data) {
            if (data.IsValid) {
                $.ajax({
                    cache: false,
                    async: true,
                    type: "POST",
                    data: data.form,
                    url: "/ProductAction/AjouterProduit",
                    success: function (response) {
                        $(document).foundation('product', 'successAddProductToCart', response);
                    },
                    beforeSend: function () {
                        Foundation.libs.common.showPreloader();
                    },
                    error: function (response) {
                        //alert("oups, impossible de vous montrer le rendu de votre bijou.");
                    }
                }).fail(function (e) {
                    Foundation.libs.common.hidePreloader();
                });
            }
            else {
                Foundation.libs.common.hidePreloader();
                var popinShippingMethodUpdate = $("#shipping-method-update-wrapper");
                popinShippingMethodUpdate.html(data._ChangeModal);
                popinShippingMethodUpdate.foundation('reveal', 'open');
            }
        },
        successAddProductToCart: function (data) {
            if (data.IsValid) {
                // MAJ du datalayer
                $(document).foundation('common', 'refreshMasterTagData', data._MasterTagJson);
                $(document).foundation('common', 'refreshMasterTag');

                // Tracking via TagCo
                $(document).foundation('mastertag', 'trackAddToCart', { trigger: 'ajout_panier', category: 'ajout panier' });

                if (typeof data.UrlToRedirect !== "undefined") {
                    Foundation.libs.common.showPreloader();
                    window.location = data.UrlToRedirect;
                }
                else {
                    $('#product-informations').html(data._ProductInformations);

                    // Feedback en affichant le survol du panier si on n'est pas sur mobile
                    Foundation.libs.common.clearLightCart();

                    // Affichage de la modale d'ajout au panier
                    var ref = data.Reference;

                    $.ajax({
                        url: '/Product/AddToCartModal',
                        data: { reference: ref },
                        success: function (result) {
                            if (result.IsValid) {
                                $('#ajout-produit-panier').html(result._AddProductModal)
                                $('#addProductReveal').foundation('reveal', 'open')
                                this.productReveal = new ProductReveal();

                                $(document).foundation('common', 'refreshMasterTagData', result._MasterTagJson);
                                $(document).foundation('common', 'refreshMasterTag');
                            }
                            Foundation.libs.common.hidePreloader();
                        },
                        beforeSend: function () {
                            Foundation.libs.common.showPreloader();
                        }
                    }).fail(function (e) {
                        Foundation.libs.common.hidePreloader();
                    });
                }
            }
            else {
                $('#erreur-globale .error-text').html(data.Message);
                $('#erreur-globale').foundation('reveal', 'open');
                Foundation.libs.common.hidePreloader();
            }

            $('#add-to-cart-button').removeAttr('disabled');
        },

        successAddPaypalExpressProductToCart: function (data) {
            Foundation.libs.common.showPreloader();
            if (data.IsValid) {
                //// MAJ du datalayer
                //$(document).foundation('common', 'refreshMasterTagData', data._MasterTagJson);
                //$(document).foundation('common', 'refreshMasterTag');
                //var event = {
                //    obj: "",
                //    trigger: "express_paypal",
                //    options: {
                //        category: "paypal express",
                //        action: "fiche produit",
                //        label: "",
                //        value: "",
                //    }
                //};

                //$(document).foundation('mastertag', 'track_tc_event', event);

                if (data.GoToUrl !== "" && data.GoToUrl !== undefined) {

                    //window.location = data.GoToUrl;
                    Foundation.libs.product.validatePaypalExpressCheckout(data.Reference);
                }
            }
            else {
                $('#erreur-globale .error-text').html(data.Message);
                $('#erreur-globale').foundation('reveal', 'open');
                Foundation.libs.common.hidePreloader();
            }

            //$('#add-to-cart-button').removeAttr('disabled');
        },
        successUpdateEGiftCardFromCart: function () {

        },
        carouselViewsNext: function () {
            var index = $(".card.card-selected").index();

            if (index != $("#navigation .card").length - 1) {
                $("#navigation .card").removeClass('card-selected');

                $($("#navigation .card").get(index + 1)).addClass('card-selected');

            } else {
                $("#navigation .card").removeClass('card-selected');

                $($("#navigation .card").get(0)).addClass('card-selected');
                //this.sliderImages.trigger('to.owl.carousel', [0]);
                //this.sliderNavigation.trigger('to.owl.carousel', [0]);
            }
            this.sliderImages.trigger('next.owl.carousel');
            this.sliderNavigation.trigger('next.owl.carousel');

            /*if (this.sliderImagesZoom != null && this.sliderImagesZoom != "undefined") {
                this.sliderImagesZoom.trigger('next.owl.carousel');
            }*/
        },
        carouselViewsPrev: function () {
            var index = $("#navigation .card.card-selected").index();

            if (index != 0) {
                $("#navigation .card").removeClass('card-selected');

                $($("#navigation .card").get(index - 1)).addClass('card-selected');

            } else {
                $("#navigation .card").removeClass('card-selected');
                $($("#navigation .card").get($("#navigation .card").length - 1)).addClass('card-selected');
                //this.sliderImages.trigger('to.owl.carousel', [$("#navigation .card").length - 1]);
                //this.sliderNavigation.trigger('to.owl.carousel', [$("#navigation .card").length - 1]);

            }
            this.sliderImages.trigger('prev.owl.carousel');
            this.sliderNavigation.trigger('prev.owl.carousel');

            /*if (this.sliderImagesZoom != null) {
                this.sliderImagesZoom.trigger('prev.owl.carousel');
            }*/

        },
        carouselViewsTo: function (index) {
            this.sliderImages.trigger('to.owl.carousel', [index, 300]);


            $("#navigation .card").removeClass('card-selected');

            $($("#navigation .card").get(index)).addClass('card-selected');

            if (this.sliderImagesZoom != null && typeof this.sliderImagesZoom.trigger === "function") {
                this.sliderImagesZoom.trigger('to.owl.carousel', [index, 300]);
            }
        },

        carouselZoomViewsTo: function (index) {

            $("#owl-product-slider-zoom-navigation .card").removeClass('card-selected');

            $($("owl-product-slider-zoom-navigation .card").get(index)).addClass('card-selected');

            if (this.sliderImagesZoom != null) {
                this.sliderImagesZoom.trigger('to.owl.carousel', [index, 300]);
            }
        },
        initCarouselZoom: function (activeView) {
            this.sliderImagesZoomElm = $('#owl-product-slider-zoom');
            this.sliderImagesZoomNavigationElm = $('#owl-product-slider-zoom-navigation');
            this.sliderImagesZoom = this.sliderImagesZoomElm.owlCarousel(this.sliderImagesZoomOpt);

            this.sliderImagesZoom.trigger('to.owl.carousel', [activeView, 300]);
            $('#zoom-modal-wrapper').foundation('reveal', 'open');
            $('#zoom-modal-wrapper').on('opened', function () {
                $(document).scrollTop(0);
                $('#zoom-fiche-produit-wrapper').on('touchstart touchmove', function (event) {
                    event.stopImmediatePropagation();
                });
                $('#owl-product-slider-zoom').on('touchstart touchmove', function (event) {
                    event.stopImmediatePropagation();
                });

            });
        },
        validatePaypalExpressCheckout: function (id = "") {
            // On supprime les éventuels messages d'erreurs et on lance la validation
            $(".errors-wrapper").hide().html('').show();

            $.ajax({
                url: '/cart/GetPaypalExpressCheckout/' + id,
                beforeSend: function (e) {
                    $(".cadeau-errors-wrapper").hide();
                    Foundation.libs.common.showPreloader();

                },
                success: function (result) {
                    if (result.IsValid) {
                        if (result.Redirection !== "" && result.Redirection !== undefined) {
                            document.location.href = result.Redirection;
                        }
                    }
                    else {
                        if (result.Redirection !== "" && result.Redirection !== undefined) {
                            document.location.href = result.Redirection;
                        } else {
                            $(document).foundation('cart', 'updateCart', result);

                            var html = '';

                            if (result.Erreurs != null && result.Erreurs.length > 0) {
                                for (var i = 0; i < result.Erreurs.length; i++) {
                                    if (result.Erreurs[i] != '') {
                                        html += '<p class="a-warning">' + result.Erreurs[i] + '</p>';
                                    }
                                }

                                $(document).foundation('cart', 'updateCartErrors', html);

                                Foundation.libs.common.hidePreloader();
                                $('.global-errors-wrapper').hide().html(html).fadeIn();
                            }
                        }
                    }
                }
            }).fail(function (result) {
                $('.global-errors-wrapper').hide().html("Une erreur est survenue. Merci de réessayer.").fadeIn();
                Foundation.libs.common.hidePreloader();
            });
        },
        toggleDeployDescription: function (e) {
            let title = e.target;
            let wrapper = title.parentElement;
            let dropdown = wrapper.querySelector('.panel-dropdown');

            if (title.classList.contains('-active')) {
                title.classList.remove('-active');
                $(dropdown).slideUp();
                dropdown.classList.remove('-active');
            } else {
                title.classList.add('-active');
                $(dropdown).slideDown()
                dropdown.classList.add('-active');
            }
        },
        trackProduct: function (trigger, id, category) {
            $(document).foundation('mastertag', 'track_tc_event',
            {
                obj: "",
                trigger: trigger,
                options: {
                    id: id,
                    category: category,
                    action: tc_vars.product_category,
                    label: tc_vars.product_name + "|" + tc_vars.product_id,
                    value: tc_vars.product_unitprice_ati,
                    product_cat1: tc_vars.product_cat1,
                    product_cat2: tc_vars.product_cat2,
                    product_cat3: tc_vars.product_cat3,
                    product_category: tc_vars.product_category,
                    product_currency: tc_vars.product_currency,
                    product_discount_tf: tc_vars.product_discount_tf,
                    product_discount_ati: tc_vars.product_discount_ati,
                    product_gravable: tc_vars.product_gravable,
                    product_engraved: tc_vars.product_engraved,
                    product_customizable: tc_vars.product_customizable,
                    product_id: tc_vars.product_id,
                    product_name: tc_vars.product_name,
                    product_promo: tc_vars.product_promo,
                    product_promo_label: tc_vars.product_promo_label,
                    product_quantity: tc_vars.product_quantity,
                    product_rating: tc_vars.product_rating,
                    product_size: tc_vars.product_size,
                    product_trademark: tc_vars.product_trademark,
                    product_unitprice_ati: tc_vars.product_unitprice_ati,
                    product_unitprice_tf: tc_vars.product_unitprice_tf
                }
            });
        }
    };
}(jQuery, window, window.document));